import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { OAuthService } from 'angular-oauth2-oidc'


@Component({
  selector: 'app-callback',
  template: '',
  imports: []
})
export class CallbackComponent {

  constructor(
    private readonly router: Router,
    private readonly oauthService: OAuthService
  ) {
    // console.log('Callback component', this.router.url)

    // try to log in using existing tokens
    this.oauthService.loadDiscoveryDocumentAndTryLogin().then((result) => {
      // console.log('loadDiscoveryDocumentAndTryLogin returned', result)
      // console.log('CallBack after login', this.oauthService.hasValidAccessToken(), this.oauthService.hasValidIdToken())

      // if login is successful, go to home
      if (this.oauthService.hasValidIdToken()) {
        this.router.navigate(['home'])
      }
    })
  }
}
